import Cookies from 'js-cookie';
import cx from 'clsx';
import React, { Fragment, MouseEvent, useEffect, useState } from 'react';
import styles from './CookieNotice.module.scss';
import utilityStyles from 'styles/global/utility.module.scss';
import { Button, Typography } from 'components/elements';
import { FormattedMessage, useIntl } from 'react-intl';
import { isWebcache } from 'utils/routes';

const COOKIE_CONSENT = 'COOKIE_CONSENT';
const ONE_YEAR_FROM_NOW = new Date(new Date().setFullYear(new Date().getFullYear() + 1));

interface OwnProps {}

const CookieNotice: React.FC<OwnProps> = props => {
  const [isCookieSet, setIsCookieSet] = useState(false);
  const { formatMessage } = useIntl();

  useEffect(() => {
    if (Cookies.get(COOKIE_CONSENT)) {
      setIsCookieSet(true);
    }
  }, []);

  const cookieBarStyles = cx({
    [utilityStyles.elevation2]: true,
    [styles.wrapper]: true,
    [styles.hidden]: isCookieSet || isWebcache(),
  });

  const setCookie = (name: string, value: string, expires: number | Date | undefined, path: string) => {
    Cookies.set(name, value, { expires, path });
  };

  const handleCookieConsentClick = (e: MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    setCookie(COOKIE_CONSENT, 'true', ONE_YEAR_FROM_NOW, '/');
    setIsCookieSet(true);
  };

  const isCookieDisabled = typeof window !== 'undefined' && window.navigator && !window.navigator.cookieEnabled;

  if (isCookieSet) {
    return null;
  }

  return (
    <div className={cookieBarStyles}>
      <div className={styles.container}>
        {isCookieDisabled && (
          <p>
            <FormattedMessage id="cookiesDisabled" />
          </p>
        )}
        {!isCookieDisabled && (
          <Fragment>
            <Typography
              mobile="new_ibm_regular_16"
              tablet="new_ibm_regular_16"
              desktop="new_ibm_regular_16"
              className={styles.cookieNoConsent}
              as="div"
              dangerouslySetInnerHTML={{ __html: formatMessage({ id: 'cookieNoConsent' }) }}
            />
            <div>
              <Button className={styles.button} onClick={handleCookieConsentClick}>
                <FormattedMessage id="cookieButton" />
              </Button>
            </div>
          </Fragment>
        )}
      </div>
    </div>
  );
};

export default CookieNotice;
